const ZIP_BATCH_SIZE = 100;
export const isAbortError = (error) => error?.name === 'AbortError';
/**
 * Fetch every document and add it to the archive, returning the names of the
 * ones that could not be fetched.
 *
 * A file we fail to fetch must not leave the archive quietly short of it, so
 * failures are counted rather than only logged. Aborting is not a per-file
 * failure and stops the whole run.
 */
export const collectDocumentsIntoZip = async (documents, zip, signal) => {
    const failedNames = [];
    for (let i = 0; i < documents.length; i += ZIP_BATCH_SIZE) {
        const chunk = documents.slice(i, i + ZIP_BATCH_SIZE);
        await Promise.all(chunk.map(async (doc) => {
            try {
                if (!doc.downloadUrl) {
                    throw new Error('Download URL is null');
                }
                const response = await fetch(doc.downloadUrl, { signal });
                if (!response.ok) {
                    // Without this the storage error body is zipped up under the
                    // document's own name, so the file looks present but is not.
                    throw new Error(`Request failed with status ${response.status}`);
                }
                zip.file(doc.name, await response.blob());
            }
            catch (error) {
                if (isAbortError(error)) {
                    throw error;
                }
                console.error(`Failed to download document: ${doc.name}`, error);
                failedNames.push(doc.name);
            }
        }));
    }
    return failedNames;
};
